// extracted by mini-css-extract-plugin
module.exports = {"mutedGray":"#9b9b9b","spinner":"style-module--spinner--1dNao","light":"style-module--light--3ooHO"};